import { useState, useEffect } from "react";
import { Pricing } from "../../pricing";
import { getListPrice } from "../../bridgeAPIService";

interface PriceDisplayProps {
    pricing: Pricing;
    modelNumber: string;
}

/**
 * The PriceDisplay function component takes a model number and gets a list
 * price corresponding to the pricing permission level from Bridge API.
 */
export const PriceDisplay = (props: PriceDisplayProps) : JSX.Element => {
    const [usListPrice, setUSListPrice] = useState('');
    const [caListPrice, setCAListPrice] = useState('');

    useEffect(() => {
        if (props.pricing === Pricing.ALL || props.pricing === Pricing.US) {
            try {
                // get US list price
                getListPrice(props.modelNumber, false).then(s => {
                    if (s && s !== 'No List Price') {
                        s = '$' + s.replace('.00', '');
                    }
                    setUSListPrice(s);
                });
            } catch {}
        }
        if (props.pricing === Pricing.ALL || props.pricing === Pricing.CA) {
            try {
                // get Canadian list price
                getListPrice(props.modelNumber, true).then(s => {
                    if (s && s !== 'No List Price') {
                        s = '$' + s.replace('.00', '');
                    }
                    setCAListPrice(s);
                });
            } catch {}
        }
    // when props.pricing or props.modelNumber changes, call useEffect.
    }, [props.pricing, props.modelNumber]);

    if (usListPrice !== '' && caListPrice !== '') {
        return (
            <h4 className='price-display'>
                <small>USD List Price:</small> <span className='us-price'>{usListPrice}</span>&nbsp;
                <small>CAD List Price:</small> <span className='ca-price'>{caListPrice}</span>
            </h4>
        );
    }
    if (usListPrice !== '') {
        return (
            <h4 className='price-display'>
                <small>USD List Price:</small> <span className='us-price'>{usListPrice}</span>
            </h4>
        );
    }
    if (caListPrice !== '') {
        return (
            <h4 className='price-display'>
                <small>CAD List Price:</small> <span className='ca-price'>{caListPrice}</span>
            </h4>
        );
    }
    return (<></>);
}
